/* ===== Dolce Pépé – Cart Drawer logic (fixed + stable) ===== */
(() => {
  const THRESHOLD_CENTS = 6000;     // €60 thresholds
  const TIMER_MINUTES   = 12;       // 12:00
  const TIMER_KEY       = 'dp_cart_timer_end_v2';

  let els = {};           // DOM refs
  let initDone = false;   // voorkomt dubbele timers
  let lastTotal = null;   // voorkomt oude states

  const money = c => '€' + (c/100).toFixed(2).replace('.', ',');

  /* ---------------- FIND ELEMENTS ---------------- */
  function findEls() {
    const root = document.querySelector('[data-dp-cart-extras]');
    if (!root) return false;

    els.root   = root;
    els.fill   = root.querySelector('[data-dp-fs-fill]');
    els.status = root.querySelector('[data-dp-fs-status]');
    els.timer  = root.querySelector('[data-dp-timer]');
    els.clock  = root.querySelector('[data-dp-timer-clock]');

    return !!(els.fill && els.status && els.clock);
  }

  /* ---------------- TIMER LOGIC ---------------- */
  function ensureTimer(itemCount) {
    if (!els.timer) return;

    if (itemCount > 0) {
      // reset timer if no valid deadline exists
      const raw = localStorage.getItem(TIMER_KEY);
      const now = Date.now();

      if (!raw || parseInt(raw, 10) < now) {
        localStorage.setItem(TIMER_KEY, String(now + TIMER_MINUTES * 60000));
      }

      els.timer.hidden = false;

    } else {
      // reset EVERYTHING when cart is empty
      localStorage.removeItem(TIMER_KEY);
      els.timer.hidden = true;
      els.clock.textContent = "12:00";   // reset visually
    }
  }

  function tickTimer() {
    if (!els.clock || !els.timer) return;

    const raw = localStorage.getItem(TIMER_KEY);

    if (!raw) {
      els.timer.hidden = true;
      return;
    }

    const diff = parseInt(raw, 10) - Date.now();

    if (diff <= 0) {
      localStorage.removeItem(TIMER_KEY);
      els.timer.hidden = true;
      return;
    }

    const m = Math.floor(diff / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    els.clock.textContent = `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
  }

  /* ---------------- FREE SHIPPING ---------------- */
  function renderFS(totalCents) {
    if (!els.fill || !els.status) return;

    const pct = Math.max(0, Math.min(100, Math.round(totalCents / THRESHOLD_CENTS * 100)));
    els.fill.style.width = pct + '%';

    if (totalCents >= THRESHOLD_CENTS) {
      els.status.textContent = 'Je hebt gratis verzending!';
    } else {
      els.status.textContent = `Nog ${money(THRESHOLD_CENTS - totalCents)} tot gratis verzending.`;
    }
  }

  /* ---------------- REFRESH FROM CART ---------------- */
  async function refreshFromCart() {
    try {
      const res  = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      const cart = await res.json();

      // Avoid using stale total (prevents old updates overwriting new)
      if (lastTotal !== cart.total_price) {
        lastTotal = cart.total_price;
        renderFS(cart.total_price || 0);
      }

      ensureTimer(cart.item_count || 0);

    } catch (e) {
      console.warn('[DP cart extras] cart.js error', e);
    }
  }

  /* ---------------- INITIALISE ---------------- */
  function init() {
    if (!findEls()) return; // element not yet rendered

    if (!initDone) {
      initDone = true;

      // continuous steady updates
      setInterval(tickTimer, 1000);
      setInterval(refreshFromCart, 5000);

      // theme cart update events
      document.addEventListener('cart:updated', () => {
        findEls();
        refreshFromCart();
      });

      // detect drawer re-render (Atelier replaces DOM!)
      const dialog = document.querySelector('.cart-drawer__dialog');
      if (dialog) {
        const mo = new MutationObserver(() => {
          findEls();
          refreshFromCart();
        });
        mo.observe(dialog, { childList: true, subtree: true });
      }
    }

    refreshFromCart();
    tickTimer();
  }

  /* ---------------- START ---------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // retry init in case the snippet loads late
  let retries = 0;
  const retryId = setInterval(() => {
    if (initDone) return clearInterval(retryId);
    init();
    if (++retries > 15) clearInterval(retryId);
  }, 300);

})();
